import Button from 'components/Button';
import Image from 'components/Image';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';
import { calcResize } from 'components/Layout/styles';

export const SCTA = styled.div`
  background: transparent;
  background-repeat: no-repeat;
  overflow: hidden;
  min-height: ${calcResize(300, 350)};
  padding: 0 15px;
  width: 100%;
  position: relative;
  display: flex;
  z-index: 100;
  align-items: center;
  justify-content: center;
  ${mediaBreakpointUp(
    'md',
    `
  min-height: ${calcResize(190, 650)};

  `,
  )};
`;

export const SContainer = styled(Container)`
  background: transparent;
  padding: ${calcResize(20, 45)} 0;
  z-index: 100;
`;

export const SPreText = styled.p`
  font-size: ${calcResize(10, 20)};
  color: ${props => props.theme.colors.white};
  text-transform: uppercase;
`;

export const STitleText = styled.p`
  font-size: ${calcResize(20, 60)};
  line-height: 1.2;

  color: ${props => props.theme.colors.main};
  margin-bottom: 15px;
  margin-top: 15px;
`;

export const SParagraph = styled.p`
  font-size: ${calcResize(14, 21)};
  line-height: 1.2;
  // font-weight: bold;
  color: ${props => props.theme.colors.main};
  margin-bottom: 100px;
  margin-top: 15px;
  a {
    color: ${props => props.theme.colors.main};
  }
  ${mediaBreakpointUp(
    'md',
    `
    width: 65%;
  `,
  )};
`;

export const SButton = styled(Button)`
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.accent};
  border-color: ${props => props.theme.colors.accent};
  border-radius: 0px;
  margin-right: 1rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${calcResize(14, 24)};
  width: ${calcResize(150, 250)};
`;

export const SImage = styled(Image)`
  position: absolute !important;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
`;
